import React, { useState } from "react";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { putApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import { toast } from "react-hot-toast";
import { AcceptDialog } from "../../../../../components/Elements/DialogBox/AcceptDialog";
import PopupCard from "../../../../Auth/PopupCard";
import { Modal } from "antd";
const SupportReplyDialog = ({ onOpen, onClose, ticketId, onSubmit }) => {
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAcceptDialog, setShowAcceptDialog] = useState(false);
  const maxLength = 100;
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });

  const handleSubmit = async () => {
    if (!remarks.trim()) {
      // toast.error("Please enter a reply before submitting.");
      return triggerPopup(
        "error",
        "Error",
        "Please enter a reply before submitting",
      );
    }

    try {
      setLoading(true);
      const response = await putApi({
        apiUrl: API_URLS.TICKET_REPLY,
        data: {
          ticketId: ticketId,
          reply: remarks,
        },
      });
      if (response.success) {
        // toast.success("Reply Submitted successfully!");
        // setShowAcceptDialog(true);
        triggerPopup("success", "Success", "Reply Submitted successfully");
        setTimeout(() => {
          Modal.destroyAll();
          onClose();
        }, 2000);
        setRemarks("");
      } else {
        return triggerPopup("error", "Error", "Failed to send reply");
        // toast.error(response.message || "Failed to send reply.");
      }
    } catch (error) {
      // toast.error(error.response?.data?.message || "Something went wrong.");

      return triggerPopup(
        "error",
        "Error",
        error.response?.data?.message || "Something went wrong.",
      );
    } finally {
      setLoading(false);
    }
  };
  const triggerPopup = (type, title, message, duration = 3000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), duration);
  };

  const handleAcceptClose = () => {
    setShowAcceptDialog(false);
    if (onSubmit) onSubmit();
  };

  return (
    <>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="800px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D] text-left">
            Reply to Ticket
          </h3>

          <div className="rounded-xl border mt-8 px-12">
            <div className="flex flex-col gap-6">
              <div>
                <label className="block mb-2 font-medium text-gray-700 mt-2">
                  Remarks
                </label>
                <div className="relative">
                  <textarea
                    placeholder="Type your reply here..."
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    maxLength={maxLength}
                    rows={6}
                    className="w-full p-2 border rounded-md bg-white resize-none"
                  />
                  <div className="absolute bottom-2 right-4 text-xs text-gray-400">
                    {remarks.length}/{maxLength}
                  </div>
                </div>
              </div>

              <div className="flex justify-center gap-6 p-5">
                <CustomButton
                  buttonType="button"
                  variant="ok"
                  buttonText={loading ? "Submitting..." : "Submit"}
                  onClick={handleSubmit}
                  className="text-base font-normal h-[50px] w-[160px]"
                  disabled={loading}
                />
              </div>
            </div>
          </div>
          {showPopup && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
              <PopupCard
                type={popupData.type}
                title={popupData.title}
                message={popupData.message}
              />
            </div>
          )}
        </div>
      </DialogBox>
      {/* {showAcceptDialog && (
        <AcceptDialog
          open={showAcceptDialog}
          close={handleAcceptClose}
          heading="Reply Sent"
          subheading="Reply has been successfully sent."
          success={true}
        />
      )} */}
    </>
  );
};

export default SupportReplyDialog;
